/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';

import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';
import { getProjectedIssues } from 'components/inventory/InventorySeparation/mocks/mockApi';
import { SplitPanelSelector } from 'shared/components/SplitPanelSelector';

import { ProjectedIssueDetail } from './ProjectedIssueDetail';
import { ProjectedIssueSummary } from './ProjectedIssueSummary';

const typeFilterConfig = {
    key: 'typeFilter',
    label: 'Type',
    type: FilterType.SELECT,
    enableSearch: false,
    multi: false,
    options: [
        { label: 'Short', value: 'short' },
        { label: 'Overflow', value: 'overflow' },
    ],
    deletable: true,
};
const severityFilterConfig = {
    key: 'severityFilter',
    label: 'Severity',
    type: FilterType.SELECT,
    enableSearch: false,
    multi: true,
    options: [
        { label: 'High', value: 'high' },
        { label: 'Medium', value: 'medium' },
        { label: 'Low', value: 'low' },
    ],
    deletable: true,
};

const filterConfigs = [typeFilterConfig, severityFilterConfig];

/**
 * Simple example implementation of SplitPanelSelector
 * Uses generic data to demonstrate the component functionality
 */
export function ProjectionsAndAllocations() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState({});
    const [sortBy, setSortBy] = useState('newest');

    // Fetch items on mount and when filters change
    useEffect(() => {
        // To do: get real items from api
        const fetchItems = async () => {
            setLoading(true);
            const response = await getProjectedIssues({ filterValues });
            if (response.success) {
                setItems(response.data);
            }
            setLoading(false);
        };

        fetchItems();
    }, [filterValues]);

    // Handle apply
    const handleApply = (selectedItems) => {
        // To do: open modal for multiple items
        console.log('Applied to:', selectedItems);
    };

    const handleSaveTransfer = ({ amount, fromChannel, toChannel }) => {
        // To do: wire up to API
        console.log('save transfer', amount, fromChannel, toChannel);
    };

    const handleSearch = (searchTerm) => {
        // To do: API, OR search loaded cards?
        console.log('searchTerm', searchTerm);
    };

    // Handle filter changes
    const handleFilterChange = (newFilterValues) => {
        // To do: wire up to API
        setFilterValues(newFilterValues);
    };

    // Handle sort change
    const handleSortChange = (value) => {
        console.log('Sort changed to:', value);
        setSortBy(value);
    };

    const handleApplyRecommendedAction = (item) => {
        // To do: open modal? tbd
        console.log('apply recommended action', item);
    };

    // Display config for sorting
    const displayConfig = {
        label: 'Display',
        menuTitle: 'Sort By',
        selectedValue: sortBy,
        onChange: handleSortChange,
        options: [
            { label: 'Newest', value: 'newest' },
            { label: 'Oldest', value: 'oldest' },
            { label: 'Highest Priority', value: 'highestPriority' },
            { label: 'Lowest Priority', value: 'lowestPriority' },
        ],
    };

    const renderCard = (item, state = {}) => {
        const { isActive, isSelected } = state;

        return (
            <ProjectedIssueSummary
                {...item}
                isActive={isActive}
                isSelected={isSelected}
                onApplyRecommendedAction={() => handleApplyRecommendedAction(item)}
            />
        );
    };

    const renderDetail = (item) => (
        <ProjectedIssueDetail
            {...item}
            skuName={item.name}
            wholesaleAllocationBreakdown={item.wholesale}
            firstPartyAllocationBreakdown={item.firstParty}
            totalAvailableUnits={item.totalAvailableUnits}
            onApplyRecommendedAction={() => handleApplyRecommendedAction(item)}
            onSaveTransfer={handleSaveTransfer}
        />
    );

    return (
        <>
            <div className="mb-4 text-left">
                <h2 className="text-2xl font-bold text-gray-600">Projections & Allocation Controls</h2>
                <p className="text-sm text-gray-500">{items.length} SKUs identified with potential issues</p>
            </div>
            <SplitPanelSelector
                items={loading ? [] : items}
                itemKeyField="externalSku"
                renderCard={renderCard}
                renderDetail={renderDetail}
                onApplySelected={handleApply}
                filterConfigs={filterConfigs}
                displayConfig={displayConfig}
                onFilterChange={handleFilterChange}
                title="Projected Issues"
                emptyStateMessage={loading ? 'Loading items...' : 'No items found'}
                onSearch={handleSearch}
            />
        </>
    );
}
